import { statesSlice } from '@/features/section-1/infra/store/stateSlice';
import { customDocumentTypeSlice } from '@/features/section-2/infra/store/customDocumentTypeSlice';
import languageReducer from '../../../features/section-1/infra/store/languageSlice';
import authReducer from './authSlice';
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import { combineReducers } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger'
import sessionStorage from 'redux-persist/lib/storage/session';

// Persist configuration
const persistConfig = {
  key: 'root',
  storage: sessionStorage,
  whitelist: ['language', 'auth'], // Persist language and auth state
};

// Combine reducers
const rootReducer = combineReducers({
  states: statesSlice.reducer,
  customDocumentTypes: customDocumentTypeSlice.reducer,
  language: languageReducer,
  auth: authReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

const isTestEnv = process.env.NODE_ENV === 'test';

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
  
    const base = getDefaultMiddleware(
      isTestEnv
        ? { serializableCheck: false, immutableCheck: false }
        : {
            serializableCheck: {
              ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
          }
    );
    return isTestEnv ? base : base.concat(createLogger());
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
